import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  NumberField,
  DateField,
  EditButton,
  DeleteButton,
  CreateButton,
  TopToolbar,
  FilterButton,
  SearchInput,
  BooleanInput,
} from 'react-admin';

const VacancyCategoryListActions = () => (
  <TopToolbar>
    <FilterButton />
    <CreateButton />
  </TopToolbar>
);

const vacancyCategoryFilters = [
  <SearchInput source="search" alwaysOn />,
  <BooleanInput source="isActive" />,
];

export const VacancyCategoryList = () => (
  <List
    filters={vacancyCategoryFilters}
    actions={<VacancyCategoryListActions />}
    sort={{ field: 'sortOrder', order: 'ASC' }}
  >
    <Datagrid>
      <TextField source="name" />
      <TextField source="slug" />
      <BooleanField source="isActive" />
      <NumberField source="sortOrder" />
      <NumberField source="_count.vacancies" label="Vacancies Count" />
      <DateField source="createdAt" showTime />
      <EditButton />
      <DeleteButton mutationMode="pessimistic" />
    </Datagrid>
  </List>
);
